'use strict'

import {slideToggle} from "../utils/slideToggle";

const DonationShare = {
    init: function () {
        const switcher = document.querySelector('.radio__ctn.switch');
        if (switcher) {
            const radioButtons = document.getElementsByName('share_type');
            if (radioButtons) {
                radioButtons.forEach(radio => {
                    radio.addEventListener('change', () => {
                        if (radio.checked) {
                            // Masquer toutes les sections d'abord
                            const sections = document.querySelectorAll('.c-form__section');
                            sections.forEach(section => {
                                if (section.style.display !== 'none') {
                                    slideToggle(section); // Masque la section visible
                                }
                            });

                            // Afficher la section correspondante après un délai
                            setTimeout(() => {
                                const targetSection = document.querySelector(`.c-form__section[data-type="${radio.id}"]`);
                                if (targetSection && targetSection.style.display === 'none') {
                                    slideToggle(targetSection); // Affiche la section cible
                                }
                            }, 300); // Délai pour laisser l'animation de fermeture se terminer
                        }
                    });
                });

                // Initialiser l'état au chargement
                const checkedRadio = document.querySelector('input[name="share_type"]:checked');
                if (checkedRadio) {
                    const initialSection = document.querySelector(`.c-form__section[data-type="${checkedRadio.id}"]`);
                    if (initialSection) {
                        // Masquer toutes les sections sauf celle qui doit être visible
                        const allSections = document.querySelectorAll('.c-form__section');
                        allSections.forEach(section => {
                            if (section !== initialSection) {
                                section.style.display = 'none';
                            }
                        });
                    }
                }
            }
        }

        const titleFirstname = document.querySelector('.h1 span');
        const inputFirstname = document.querySelector('input[name="firstname"]');
        const inputLastname = document.querySelector('input[name="lastname"]');
        const messageName = document.querySelector('.message-name');
        const messageFirstname = document.querySelector('.message-firstname');
        const urlParams = new URLSearchParams(window.location.search);

        urlParams.forEach((value, key) => {

            if (key === "firstname") {
                if (titleFirstname) {
                    titleFirstname.textContent = value;
                }
                if (inputFirstname) {
                    inputFirstname.value = value;
                }
                if (messageFirstname) {
                    messageFirstname.textContent = value;
                }
            }
            if (key === "lastname") {
                if (inputLastname) {
                    inputLastname.value = value;
                }
                if (messageName) {
                    messageName.textContent = value;
                }
            }
        });

        if(inputFirstname){
            inputFirstname.addEventListener('keyup', () => {
                const value = inputFirstname.value;
                if (titleFirstname) {
                    titleFirstname.textContent = value;
                }
                if (messageFirstname) {
                    messageFirstname.textContent = value;
                }
            });
        }
        if(inputLastname){
            inputLastname.addEventListener('keyup', () => {
                const value = inputLastname.value;
                if (messageName) {
                    messageName.textContent = value;
                }
            });
        }

    }
}

export default DonationShare;